"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createApolloClient = createApolloClient;
exports.initializeApollo = initializeApollo;
exports.useApollo = useApollo;
var _react = require("react");
var _client = require("@apollo/client");
var _deepmerge = _interopRequireDefault(require("deepmerge"));
var _apolloUploadClient = require("apollo-upload-client");
var _isomorphicUnfetch = _interopRequireDefault(require("isomorphic-unfetch"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var apolloClient;
function createApolloClient(apiUri) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isBrowser = typeof window !== 'undefined';
  var link = (0, _apolloUploadClient.createUploadLink)({
    uri: apiUri,
    credentials: 'include',
    fetch: !isBrowser ? _isomorphicUnfetch.default : undefined
  });
  return new _client.ApolloClient({
    connectToDevTools: isBrowser,
    ssrMode: !isBrowser,
    // Disables forceFetch on the server (so queries are only run once)
    link,
    cache: new _client.InMemoryCache().restore(initialState)
  });
}
function initializeApollo(apiUri) {
  var _apolloClient2;
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var _apolloClient = (_apolloClient2 = apolloClient) !== null && _apolloClient2 !== void 0 ? _apolloClient2 : createApolloClient(apiUri);

  // If your page has Next.js data fetching methods that use Apollo Client, the initial state
  // get hydrated here
  if (initialState) {
    // Get existing cache, loaded during client side data fetching
    var existingCache = _apolloClient.extract();

    // Merge the existing cache into data passed from getStaticProps/getServerSideProps
    var data = (0, _deepmerge.default)(initialState, existingCache);

    // Restore the cache with the merged data
    _apolloClient.cache.restore(data);
  }
  // For SSG and SSR always create a new Apollo Client
  if (typeof window === 'undefined') return _apolloClient;
  // Create the Apollo Client once in the client
  if (!apolloClient) apolloClient = _apolloClient;
  return _apolloClient;
}
function useApollo(apiUri, initialState) {
  var store = (0, _react.useMemo)(() => initializeApollo(apiUri, initialState), [initialState]);
  return store;
}